import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, deleteToken } from 'firebase/messaging';
import { CH_INSTALLATION } from '../constants/firebase';

const firebaseConfig = {
  messagingSenderId: process.env.FCM_SENDER_ID,
  apiKey: process.env.FCM_API_KEY,
  projectId: process.env.FCM_PROJECT_ID,
  appId: process.env.FCM_APP_ID,
};

let app;
let messaging;
let messagingInitPromise;

const hasFirebaseConfig = () =>
  Boolean(
    firebaseConfig.messagingSenderId &&
      firebaseConfig.apiKey &&
      firebaseConfig.projectId &&
      firebaseConfig.appId,
  );

export const getMessagingInstance = async () => {
  if (messaging !== undefined) {
    return messaging;
  }

  if (!messagingInitPromise) {
    messagingInitPromise = (async () => {
      if (typeof window === 'undefined' || !hasFirebaseConfig()) {
        messaging = null;
        return null;
      }

      try {
        const supported = await isSupported();
        if (!supported) {
          messaging = null;
          return null;
        }

        if (!app) {
          app = initializeApp(firebaseConfig);
        }
        messaging = getMessaging(app);
        return messaging;
      } catch {
        messaging = null;
        return null;
      }
    })();
  }

  return messagingInitPromise;
};

const deleteDeviceToken = async () => {
  const instance = await getMessagingInstance();
  const deviceToken = localStorage.getItem(CH_INSTALLATION);
  if (deviceToken && instance) {
    await deleteToken(instance);
    localStorage.removeItem(CH_INSTALLATION);
  }
  return deviceToken;
};

export { deleteDeviceToken };
